import { render, staticRenderFns } from "./mark_as_paid.vue?vue&type=template&id=bbedc06a&scoped=true"
import script from "./mark_as_paid.vue?vue&type=script&lang=js"
export * from "./mark_as_paid.vue?vue&type=script&lang=js"
import style0 from "./mark_as_paid.vue?vue&type=style&index=0&id=bbedc06a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbedc06a",
  null
  
)

export default component.exports